import * as Cookies from "es-cookie"
import store from "./store"
import { DLogin } from "apis/DLogin"
import { DLogout } from "apis/DLogout"
import { getLocale } from "utils/locale"
import { getJWToken } from "apis/JWToken"
import { storeTimeoutModalIsOpen } from "actions"

export const handleAuthentication = async ({ history }) => {
  const { pathname } = document.location

  if (!window.location.search) {
    history.push("/error", { pathname })
  } else {
    // codeの存在チェック＆state値の合致チェック
    const paramArray = window.location.search.substring(1).split("&")
    const code = paramArray.find(param => {
      return !param.indexOf("code=")
    })
    const uriAuthState = paramArray.find(param => {
      return !param.indexOf("state=")
    })
    const cookieAuthState = Cookies.get("authStateToken")
    Cookies.remove("authStateToken")

    // nonceチェック用
    const cookieNonce = decodeURIComponent(Cookies.get("nonce"))
    Cookies.remove("nonce")

    const targetUrl = decodeURIComponent(uriAuthState).slice(22)

    if (
      code &&
      code.slice(5) &&
      uriAuthState &&
      cookieAuthState === uriAuthState.slice(6)
    ) {
      // チェックOKの場合、cookieに保存されたstateを削除し、getTokenAPIを叩く
      const codeValue = code.slice(5)

      const locale = getLocale()

      // API実行開始後に指定の秒数が経過後、タイムアウト処理を実行する
      const timeId = setTimeout(() => {
        store.dispatch(storeTimeoutModalIsOpen(true))
      }, 5000)

      const { payload, error } = await getJWToken(codeValue, locale, "as")

      // タイマーを解除する
      clearTimeout(timeId)

      if (payload && !error) {
        if (checkNonce(payload.nonce, cookieNonce)) {
          Cookies.set("JWToken", payload.token, { secure: true })
          window.history.replaceState({}, document.title, targetUrl)
          window.location.reload()
        } else {
          // nonceチェックエラー
          DLogout()
        }
      } else {
        store.dispatch(storeTimeoutModalIsOpen(false))

        switch (Math.floor(error.status / 100)) {
          case 4:
            // dprofile_DcmProfileAvailable 利用不可の場合
            if (error.status === 403) {
              history.push("/error", { pathname })
            } else {
              // パラメータ不足、INVALID_GRANT、INVALID_TOKEN
              // ここのあるべきを考える必要あり
              // コールバック画面にてエラーを表示した上で、数秒後にDLoginに遷移とかが良さそう。

              DLogin({ prompt: true })
            }
            break
          // 500系 or undefind（サーバエラーなど）
          default:
            history.push("/error", { pathname })
            break
        }
      }
    } else {
      history.push("/error", { pathname })
    }
  }
}

const checkNonce = (nonce, cookieNonce) => {
  if (nonce && cookieNonce && nonce === cookieNonce) {
    return true
  } else {
    return false
  }
}
